import {
  Box,
  Button,
  Checkbox,
  Paper,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from '@mui/material'
import { Item } from '../../common/snippets'
import * as sx from '../../common/stylesInline/report_daily_branch'
import React, { useEffect, useLayoutEffect, useState } from 'react'
import Datepicker from '../../common/datePicker'
import moment from 'moment'
import { colors, focusElemnt, navigation1 } from '../../common/helper'
import DropDownOA from '../../common/dropDownOA'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { API_CACHE_DURATION, pendingOutDelivery, updateOutDelivery, urls, xlCol } from '../../common/constants'
import { GetRequest, GetRequestCachedV3, PostRequest } from '../../common/api'
import useToken from '../../helpers/useTokens'
import { getTableHeaders, tableHeadersfilter, getOutDeliveryFilterPlaceholders, getAllOptionLabel, translateOutDeliveryStatus } from './const'
import { useTranslation } from '../../../i18n/I18nProvider'
import { methodOfPaymentDataAtom } from '../../common/jotaiState/bookingStateAtoms'
import { useAtom, useAtomValue } from 'jotai'
import LineInputV3 from '../../common/lineInputV3'
import { useRef } from 'react'
import { CargoRoleRightsAtom, companySettingsAtom, luggageSendOTP } from '../../common/jotaiState/commonStateAtoms'
import { alertAtom, modalAtom } from '../../common/jotaiState/globalStateAtoms'
import OTPModal from '../BrnchUsrMaster/UserMaster/OTPModal'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { BookingConfirmMpesa } from '../../common/bookingConfirmMpesa'
const paymentFields = ["DueAmount","AdditionalDeliveryCartage","AdditionalHamaliCharges","ExtraHamali","DemurrageChg"]
export const OutDelivery = () => {
  const { translations } = useTranslation()
  const od = translations?.outDelivery || {}
  const cmn = translations?.common || {}
  const fp = getOutDeliveryFilterPlaceholders(translations)
  const tableHeaders = getTableHeaders(translations)
  const allLabel = getAllOptionLabel(translations)
  const [companySettings] = useAtom(companySettingsAtom)
  const { DefaultCurrencyID, UseToPayAsCOD } = companySettings
  const [selectedRadio, setSelectedRadio] = useState(1)
  const [otpOn, setOTPON] = useState(2)
  const [showAll, setShowAll] = useState(false)
  const [memoFromDate, setMemoFromDate] = useState(moment(new Date()))
  const [memoToDate, setMemoToDate] = useState(moment(new Date()))
  const [tillDate, setTillDate] = useState(false)
  const theme = useTheme()
  const [isExpanded, setIsExpanded] = useState(false)
  const [showMore, setShowMore] = useState(false)
  const { loginData } = useToken()
  const [methodOfPaymentData, setMethodOfPaymentData] = useAtom(methodOfPaymentDataAtom)
  const [tableHeight, setTableHeight] = useState('auto')
  const { intBranchID, intCompanyID, intUserID, intBranchCityID,IsBranchAdmin,IsMTPLAdmin,IsAdmin } = loginData
  const roleRights = useAtomValue(CargoRoleRightsAtom)
  const RoleRights = roleRights?.Table1?.[0] || {}
  const { AllowViewAllBranchReport, AllowViewAllBranchOfCityReport } = RoleRights
  const enableBranchChange = AllowViewAllBranchReport || AllowViewAllBranchOfCityReport || IsBranchAdmin || IsMTPLAdmin || IsAdmin
  const enableCityChange = AllowViewAllBranchReport  || IsBranchAdmin || IsMTPLAdmin || IsAdmin
  const [sourceCityList, setSourceCityList] = useState([])
  const [sourceBranchList, setSourceBranchList] = useState([])
  const [sourceBranchListFilter, setSourceBranchListFilter] = useState([])
  const [destinationCityList, setDestinationCityList] = useState([])
  const [destinationBranchList, setDestinationBranchList] = useState([])
  const [destinationBranchListFilter, setDestinationBranchListFilter] = useState([])
  const [userList, setUserList] = useState([])
  const [userListFilter, setUserListFilter] = useState([])
  const [sourceCity, setSourceCity] = useState({})
  const [destinationCity, setDestinationCity] = useState({})
  const [sourceBranch, setSourceBranch] = useState({})
  const [destinationBranch, setDestinationBranch] = useState({})
  const [user, setUser] = useState({})
  const [dataList, setDataList] = useState([])
  const [tableData, setTableData] = useState([])
  const [filterValues, setFilterValues] = useState({})
  const tableRef = useRef(null)
  const [modal, setModal] = useAtom(modalAtom)
  const [, setAlert] = useAtom(alertAtom)
  const [OTP, setOTP] = useState('')
  const { palette: cs } = theme
  const [filters,setFilters] = useState({})
  const [challanList, setChallanList] = useState([])
  const [senderNameList, setSenderNameList] = useState([])
  const [senderNumberList, setSenderNumberList] = useState([])
  const [senderGSTNList, setSenderGSTNList] = useState([])
  const [challanFilter, setChallanFilter] = useState({})
  const [senderNameFilter, setSenderNameFilter] = useState({})
  const [senderNumberFilter, setSenderNumberFilter] = useState({})
  const [senderGSTNFilter, setSenderGSTNFilter] = useState({})
  const [showMpesa, setShowMpesa] = useState(false)
  
  const handleChange = (e) => {
    setSelectedRadio(+e.target.value)
  }
  const handleOTPChange = (e) => {
    setOTPON(+e.target.value)
  }
  useEffect(() => {
    GetRequestCachedV3(urls.getMOFPayment, { intBranchID }, true, API_CACHE_DURATION).then((res) => {
      setMethodOfPaymentData(res?.Data?.Table || [])
    })
  }, [])
  useEffect(() => {
    if (!dataList.length) return
    const filtered = dataList.filter((row) => {
      return tableHeadersfilter.every((col) => {
        const filterVal = filterValues[col.field] || ''
        if (!filterVal) return true
        const cellValue = row[col.field] ?? ''
        return cellValue.toString().toLowerCase().includes(filterVal.toLowerCase())
      })
    })
    setTableData(filtered)
  }, [filterValues])
  useLayoutEffect(() => {
    const updateHeight = () => {
      if (!tableRef.current) return
      const rect = tableRef.current.getBoundingClientRect()
      const top = rect.top
      const viewportHeight = window.innerHeight
      const bottomPadding = 65
      const availableHeight = viewportHeight - top - bottomPadding

      setTableHeight(`${availableHeight}px`)
    }

    updateHeight()
    window.addEventListener('resize', updateHeight)
    window.addEventListener('scroll', updateHeight)

    return () => {
      window.removeEventListener('resize', updateHeight)
      window.removeEventListener('scroll', updateHeight)
    }
  }, [])
  const viewHeaders = [...tableHeaders]
  const headerFields = viewHeaders.map((header) => header.field)

  const handleCheck = (e) => {
    if (e.target.checked) {
      const updated = tableData.map((item) => (item.bookingid === +e.target.name ? { ...item, checked: true } : item))
      setTableData(updated)
    } else {
      const updated = tableData.map((item) => (item.bookingid === +e.target.name ? { ...item, checked: false } : item))
      setTableData(updated)
    }
  }
  const handleKeyDown = (e) => {
    if (e.key === ' ') {
      setSelectedRadio(+e.target.value)
    }
  }
  const handleToggle = () => {
    setShowMore(!showMore)
  }
  const handleMoreFilter = () => {
    const filtered = dataList.filter((item) => Object.entries(filters).every(([key, value]) => item[key] === value))
    setTableData(filtered)
  }
  const handleFilterReset=()=>{
    setFilters({})
    setChallanFilter({id:0,name:""})
    setSenderNameFilter({id:0,name:""})
    setSenderNumberFilter({id:0,name:""})
    setSenderGSTNFilter({id:0,name:""})
    setTableData(dataList)
  }
  const handleGo = async () => {
    const payload = {
      CompanyID: intCompanyID,
      UserID: intUserID,
      FromDate: memoFromDate.format('YYYY-MM-DD'),
      ToDate: memoToDate.format('YYYY-MM-DD'),
      Mode: showAll ? 0 : selectedRadio,
      BookingCityID: 0,
      BookingBranchID: 0,
      DestinationCityID: 0,
      DestinationBranchID: 0,
      AssignedUserID: 0,
    }
    try {
      const response = await GetRequest(urls.getAllPendingLR, payload)
      if (response.status === 'Success') {
        const list = response?.Data?.Table || []
        const { sourceCityList, destinationCityList, sourceBranchList, destinationBranchList, userList } = list.reduce(
          (acc, item) => {
            const {
              BookingCity,
              BookingCityID,
              DestinationCity,
              DestinationCityID,
              BookingBranch,
              BookingBranchID,
              DestinationBranch,
              DestinationBranchID,
              OutDeliveryOtpAssignedTo,
              OutDeliveryOtpAssignedToID,
            } = item
            if (!acc.set1.has(BookingCityID)) {
              acc.sourceCityList.push({ id: BookingCityID, name: BookingCity })
              acc.set1.add(BookingCityID)
            }
            if (!acc.set2.has(DestinationCityID)) {
              acc.destinationCityList.push({ id: DestinationCityID, name: DestinationCity })
              acc.set2.add(DestinationCityID)
            }
            if (!acc.set3.has(BookingBranchID)) {
              acc.sourceBranchList.push({ id: BookingBranchID, name: BookingBranch, cityid: BookingCityID })
              acc.set3.add(BookingBranchID)
            }
            if (!acc.set4.has(DestinationBranchID)) {
              acc.destinationBranchList.push({ id: DestinationBranchID, name: DestinationBranch, cityid: DestinationCityID })
              acc.set4.add(DestinationBranchID)
            }
            if (!acc.set5.has(OutDeliveryOtpAssignedToID)) {
              acc.userList.push({ id: OutDeliveryOtpAssignedToID, name: OutDeliveryOtpAssignedTo, cityid: DestinationCityID, branchid: DestinationBranchID })
              acc.set5.add(OutDeliveryOtpAssignedToID)
            }
            return acc
          },
          {
            sourceCityList: [],
            destinationCityList: [],
            sourceBranchList: [],
            destinationBranchList: [],
            userList: [],
            set1: new Set(),
            set2: new Set(),
            set3: new Set(),
            set4: new Set(),
            set5: new Set(),
          }
        )
        if (sourceCityList.length) {
          if (sourceCityList.length > 1) {
            sourceCityList.unshift({ id: 0, name: allLabel })
          }
          setSourceCityList(sourceCityList)
          setSourceCity(sourceCityList[0])
        }
        if (sourceBranchList.length) {
          if (sourceBranchList.length > 1) {
            sourceBranchList.unshift({ id: 0, name: allLabel })
          }
          setSourceBranchList(sourceBranchList)
          setSourceBranchListFilter(sourceBranchList)
          setSourceBranch(sourceBranchList[0])
        }
        if (destinationCityList.length) {
          setDestinationCityList(destinationCityList)
          const currentCity = destinationCityList.find((a) => a.id === intBranchCityID) || {}
          setDestinationCity(currentCity)
        }
        if (destinationBranchList.length) {
          const ownBranch = destinationBranchList.filter((a) => a.id === intBranchID) || []
          const ownCityBranches = destinationBranchList.filter((a) => a.cityid === intBranchCityID) || []
          setDestinationBranchList(enableBranchChange ? destinationBranchList : ownBranch)
          setDestinationBranchListFilter(enableCityChange ? destinationBranchList : enableBranchChange ? ownCityBranches : ownBranch)
          setDestinationBranch(ownBranch?.[0] || {})
        }
        if (userList.length) {
          setUserList(userList)
          setUserListFilter(userList)
          setUser(userList[0])
        }
      }
    } catch (error) {}
  }
  const validateDeliver = () => {
    const checked = tableData.filter((a) => a.checked)
    if (checked.length) {
      if (checked.some((a) => !a.PaymentModeID)) {
        setAlert({ show: true, msg: od.pleaseSelectPaymentModeForAllSelectedLrs || 'Please select payment mode for all selected LRs', nextId: '', success: 'false' })
        return false
      }
      return true
    }
    setAlert({ show: true, msg: od.pleaseSelectAtLeastOneLr || 'Please select at least one LR', nextId: '', success: 'false' })
    return false
  }
  const validateReturn = () => {
    const checked = tableData.filter((a) => a.checked)
    if (checked.length) {
      return true
    }
    setAlert({ show: true, msg: od.pleaseSelectAtLeastOneLr || 'Please select at least one LR', nextId: '', success: 'false' })
    return false
  }
  const deliverLRs = () => {
    const checked = tableData.filter((a) => a.checked)
    const { BookingIDs, strTotalDuess, strExtraHamalis, strDeliveryCharges, strDelCargates, strDiscounts, strGSTs, strDemurrageChgs,PaymentModeIDs,RecNames,RecContactNos } =
      checked.reduce(
        (acc, cur, i) => {
          const sep = i === 0 ? '' : ','
          acc.BookingIDs += sep + cur.bookingid
          acc.strTotalDuess += sep + cur.DueAmount
          acc.strExtraHamalis += sep + cur.ExtraHamali
          acc.strDeliveryCharges += sep + cur.DeliveryChg
          acc.strDelCargates += sep + cur.AdditionalDeliveryCartage
          acc.strDiscounts += sep + cur.DeliveryDisc
          acc.strGSTs += sep + cur.DeliveryGST
          acc.strDemurrageChgs += sep + cur.DemurrageChg
          acc.PaymentModeIDs += sep + cur.PaymentModeID
          acc.RecNames += sep + cur.RecName
          acc.RecContactNos += sep + cur.RecMobileNo
          return acc
        },
        {
          BookingIDs: '',
          strTotalDuess: '',
          strExtraHamalis: '',
          strDeliveryCharges: '',
          strDelCargates: '',
          strDiscounts: '',
          strGSTs: '',
          strDemurrageChgs: '',
          PaymentModeIDs:'',
          RecNames:'',
          RecContactNos:''
        }
      )

    const payload = {
      CompanyID: intCompanyID,
      LoginUserID: intUserID,
      BookingIDs,
      EventMode: 4,
      AssignedToUserID: -1,
      AssignedByUserID: -1,
      BaseUserID: intUserID,
      strTotalDuess,
      strExtraHamalis,
      strDeliveryCharges,
      strDelCargates,
      strDiscounts,
      strGSTs,
      strDemurrageChgs,
      VehicleID: 0,
      Remarks: '',
      PaymentModeIDs,
      RecNames,
      RecContactNos,
    }
    setModal('')
    PostRequest(urls.outDeliveryUserInsertUpdate, payload).then((res) => {
      if (res?.status === 'Success') {
        setAlert({ show: true, msg: od.outDeliverySuccessful || `Out Delivery Successful !!!`, nextId: '', success: 'true', close: () => window.location.reload() })
      }else{
        setAlert({ show: true, msg: res?.Message, nextId: '' })
      }
    })
  }
  const handleDeliver = () => {
    const checked = tableData.filter((a) => a.checked)
    if (validateDeliver()) {
      const obj = {
        StrEventType: 'Out delivery',
        intCompanyID: intCompanyID,
        intUserID: intUserID,
        strContactNo: '',
        intBookingID: 0,
        intMode: 5,
        strBookingIDs: checked.map((a) => a.bookingid).join(','),
        intOTPToUserID: checked.map((a) => a.OutDeliveryOtpAssignedToID).join(','),
      }
      luggageSendOTP(obj)
        .then((res) => {
          if (res?.Status === true) {
            setModal('OTP')
            setOTP(res?.OTP)
          } else {
          }
        })
        .catch((err) => {})
    }
  }
  const handleDeliverWithMpesa = () => {
    const checked = tableData.filter((a) => a.checked)
    if (validateDeliver()) {
      setShowMpesa(true)
    }
  }
  const handleReturn = () => {
    const checked = tableData.filter((a) => a.checked)
    if (validateReturn()) {
      const obj = {
        StrEventType: 'Out delivery',
        intCompanyID: intCompanyID,
        intUserID: intUserID,
        strContactNo: '',
        intBookingID: 0,
        intMode: 5,
        strBookingIDs: checked.map((a) => a.bookingid).join(','),
        intOTPToUserID: checked[0].OutDeliveryOtpAssignedToID,
      }
      luggageSendOTP(obj)
        .then((res) => {
          if (res?.Status === true) {
            setModal('OTPReturn')
            setOTP(res?.OTP)
          } else {
          }
        })
        .catch((err) => {})
    }
  }
  const returnLRs = () => {
    const checked = tableData.filter((a) => a.checked)
    const BookingIDs = checked.map((a) => a.bookingid).join(',')
    const payload = {
      CompanyID: intCompanyID,
      LoginUserID: intUserID,
      BookingIDs,
      EventMode: 3,
      AssignedToUserID: -1,
      AssignedByUserID: -1,
      BaseUserID: intUserID,
      strTotalDuess: '',
      strExtraHamalis: '',
      strDeliveryCharges: '',
      strDelCargates: '',
      strDiscounts: '',
      strGSTs: '',
      strDemurrageChgs: '',
      VehicleID: 0,
      Remarks: '',
      PaymentModeIDs: '',
      RecNames: '',
      RecContactNos: '',
    }
    setModal('')
    PostRequest(urls.outDeliveryUserInsertUpdate, payload).then((res) => {
      if (res?.status === 'Success') {
        setAlert({
          show: true,
          msg: od.outDeliveryReturnSuccessful || `Out Delivery Return Successful !!!`,
          nextId: '',
          success: 'true',
          close: () => window.location.reload(),
        })
      }
    })
  }
  const hanlePaymentmode = (payment, bookingId) => {
    const updated = tableData.map((item) =>
      item.bookingid === +bookingId ? { ...item, PaymentModeID: payment.ModeID, PaymentMode: payment.ModeName } : item
    )
    setTableData(updated)
  }
  const handleGenerate = async () => {
    const payload = {
      CompanyID: intCompanyID,
      UserID: intUserID,
      FromDate: memoFromDate.format('YYYY-MM-DD'),
      ToDate: memoToDate.format('YYYY-MM-DD'),
      Mode: showAll ? 0 : selectedRadio,
      BookingCityID: sourceCity?.id || 0,
      BookingBranchID: sourceBranch?.id || 0,
      DestinationCityID: destinationCity?.id || 0,
      DestinationBranchID: destinationBranch?.id || 0,
      AssignedUserID: user?.id || 0,
    }
    try {
      const response = await GetRequest(urls.getAllPendingLR, payload)
      if (response.status === 'Success') {
        const temp = response?.Data?.Table1 || []
        const dataList = temp.map((obj) =>
          Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, v === 0 && !['DueAmount', 'Outstanding','DeliveryGST'].includes(k) ? '' : v]))
        ).map((item) => {
          if (UseToPayAsCOD === 1) {
            if (item.PaymentTypeId === 2) return { ...item, PaymentTypeName: 'COD' }
            if (item.PaymentTypeId === 7) return { ...item, PaymentTypeName: 'COD(MANUAL)' }
            if (item.PaymentTypeId === 9) return { ...item, PaymentTypeName: 'COD(DDDV)' }
          }
          return item
        })
        setDataList(dataList)
        setTableData(dataList)
        const { challanList, senderNameList, senderNumberList, senderGSTNList } = dataList.reduce(
          (acc, item, i) => {
            const { ChallanNo, Sender, SenderMobileNo, SenderGSTN } = item
            if (!acc.set1.has(ChallanNo)) {
              acc.challanList.push({ id: i, name: ChallanNo })
              acc.set1.add(ChallanNo)
            }
            if (!acc.set2.has(Sender)) {
              acc.senderNameList.push({ id: i, name: Sender })
              acc.set2.add(Sender)
            }
            if (!acc.set3.has(SenderMobileNo)) {
              acc.senderNumberList.push({ id: i, name: SenderMobileNo })
              acc.set3.add(SenderMobileNo)
            }
            if (!acc.set4.has(SenderGSTN)) {
              acc.senderGSTNList.push({ id: i, name: SenderGSTN })
              acc.set4.add(SenderGSTN)
            }
            return acc
          },
          {
            challanList: [],
            senderNameList: [],
            senderNumberList: [],
            senderGSTNList: [],
            set1: new Set(),
            set2: new Set(),
            set3: new Set(),
            set4: new Set(),
          }
        )
        setChallanList(challanList)
        setSenderNameList(senderNameList)
        setSenderNumberList(senderNumberList)
        setSenderGSTNList(senderGSTNList)
      }
    } catch {}
  }
  const hanleInput = (e) => {
    const { name, value } = e.target
    const bookingid = +name.split('||')[0]
    const field = name.split('||')[1]
    const data = field === 'RecName' ? value : +value
    const currentItem = tableData.find((item) => item.bookingid === bookingid)
    currentItem[field] = data
    const Outstanding = paymentFields.reduce((acc, key) => acc + Number(currentItem[key]), 0) - Number(currentItem?.DeliveryDisc)
    currentItem.Outstanding = Outstanding
    const updated = tableData.map((item) => (item.bookingid === bookingid ? currentItem : item))
    setTableData(updated)
  }
  const handleChangeContain = (e, name) => {
    let value = e.target.value
    setFilterValues((prevFilterValues) => ({
      ...prevFilterValues,
      [name]: value,
    }))
  }
  const handleFromCitySelect = (city) => {
    setSourceCity(city)
    setIsExpanded(false)
    const filterList = city?.id ? sourceBranchList.filter((a) => a.cityid === city?.id) : sourceBranchList
    if (filterList.length > 1 && city?.id) {
      filterList.unshift({ id: 0, name: allLabel })
    }
    setSourceBranchListFilter(filterList)
    setSourceBranch(filterList[0] || {})
  }
  const handleDestCitySelect = (city) => {
    setDestinationCity(city)
    setIsExpanded(false)
    const filterList = city?.id ? destinationBranchList.filter((a) => a.cityid === city?.id) : destinationBranchList
    setDestinationBranchListFilter(filterList)
    setDestinationBranch(filterList[0] || {})
    const filterUserList = city?.id ? userList.filter((a) => a.cityid === city?.id) : userList
    setUserListFilter(filterUserList)
    setUser(filterUserList[0] || {})
  }
  const checked = tableData.filter((a) => a.checked)
  const totalOutstanding = checked.reduce((acc, cur) => acc + Number(cur.Outstanding || 0), 0)
  const mpesaData = {
    ttype: 'D',
    showMpesa: () => {
      setShowMpesa(true)
    },
    yesAction: (data) => {
      deliverLRs()
    },
    finalAmt: totalOutstanding,
    sendMobNo: "",
    noAction: () => setShowMpesa(),
  }
  return (
    <Item sx={{ padding: '0' }} className="reports">
      <Box
        sx={sx.itemsx}
        style={{
          display: 'flex',
          marginRight: '5px',
        }}
      >
        <label
          htmlFor={'isBookingDateWise'}
          style={{
            fontFamily: 'Roboto',
            fontSize: '12px',
            fontWeight: '500',
            color: '#444444',
            flexWrap: 'nowrap',
          }}
        >
          <Radio
            id={'isBookingDateWise'}
            name={`dateWiseRadio`}
            size={'medium'}
            value="1"
            checked={selectedRadio === 1}
            onChange={handleChange}
            onKeyDown={(e) => handleKeyDown(e)}
          />
          {od.bookingDateWise || 'Booking Date Wise'}
        </label>
        <label
          htmlFor={'isDelvryDateWise'}
          style={{
            fontSize: '12px',
            fontFamily: 'Roboto',
            fontWeight: '500',
            color: '#444444',
            flexWrap: 'nowrap',
          }}
        >
          <Radio
            id={'isDelvryDateWise'}
            name={`dateWiseRadio`}
            size={'medium'}
            value="2"
            checked={selectedRadio === 2}
            onChange={handleChange}
            onKeyDown={(e) => handleKeyDown(e)}
          />
          {od.receiveDateWise || 'Receive Date Wise'}
        </label>
      </Box>
      <Box sx={{ ...sx.reportFlex, paddingLeft: '15px', justifyContent: 'start', paddingBottom: '12px' }}>
        <Item sx={{ ...sx.itemsx, width: '19%' }} className="input--container bookingDatePicker">
          <Datepicker
            id="memoFromDate"
            width="100%"
            label={selectedRadio === 1 ? (od.fromBookingDate || 'From Booking Date') : (od.fromReceiveDate || 'From Receive Date')}
            value={memoFromDate}
            statusChecked={showAll}
            dateChange={(date) => {
              setMemoFromDate(date)
              focusElemnt('memoToDate')
            }}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '19%' }} className="input--container bookingDatePicker">
          <Datepicker
            id="memoToDate"
            width="100%"
            label={selectedRadio === 1 ? (od.toBookingDate || 'To Booking Date') : (od.toReceiveDate || 'To Receive Date')}
            value={memoToDate}
            statusChecked={tillDate || showAll}
            dateChange={(date) => {
              setMemoToDate(date)
              focusElemnt('memoAllLr')
            }}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '19%', maxWidth: '238px' }} className="input--container">
          <Box sx={{ ...sx.itemsxGrow, flexWrap: 'nowrap', alignItems: 'center' }}>
            <label
              htmlFor="memoAllLr"
              style={{ fontSize: '12px', width: '100%', fontWeight: '500', paddingLeft: '30px', position: 'relative' }}
            >
              <Checkbox
                id="memoAllLr"
                checked={showAll}
                sx={{ padding: 0, position: 'absolute', left: '0px', top: '8px' }}
                onChange={(e) => {
                  if (e.target.checked) {
                    if (tillDate) {
                      setTillDate(false)
                    }
                  }
                  setShowAll(e.target.checked)
                }}
                onKeyDown={(e) => {
                  navigation1(e, 'memoNext1', 'memoToDate')
                }}
              />
              {od.showAllPendingLrsAtDestinationBranch || 'Show All Pending LRs At Destination Branch'}
            </label>
          </Box>
          <Button
            id="memoNext1"
            style={{ background: cs.secondary.main, borderRadius: '6px', margin: '0px' }}
            onKeyDown={(e) => {
              navigation1(e, 'memoSourceCity', 'memoAllLr')
            }}
            className="btn add-btn"
            variant="contained"
            color="error"
            onClick={handleGo}
          >
            {cmn.go || 'GO'}
          </Button>
        </Item>
        <Item sx={{ ...sx.itemsx, width: '19%' }}>
          <DropDownOA
            id="memoSourceCity"
            nextId="memoSourceBranch"
            prevId="memoNext1"
            label={od.sourceCity || 'Source City'}
            width="100%"
            searchPlaceholder={od.searchSourceCity || `Search Source City`}
            defaultvalue={sourceCity?.name || ''}
            value={sourceCity?.name || ''}
            data={sourceCityList}
            dataKey={`name`}
            idKey={`id`}
            onSelect={handleFromCitySelect}
            onSelResetVal={true}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '19%' }}>
          <DropDownOA
            type ={'set_default'}
            id="memoSourceBranch"
            nextId="memoDestCity"
            prevId="memoSourceCity"
            label={od.sourceBranch || 'Source Branch'}
            defaultvalue={sourceBranch?.name || ''}
            value={sourceBranch?.name || ''}
            width="100%"
            searchPlaceholder={od.searchSourceBranch || `Search Source Branch`}
            data={sourceBranchListFilter}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(value) => {
              setSourceBranch(value)
              setIsExpanded(false)
            }}
            onSelResetVal={true}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '19%' }}>
          <DropDownOA
            type ={'set_default'}
            id="memoDestCity"
            nextId="memoDestBranch"
            prevId="memoSourceBranch"
            label={od.destinationCity || 'Destination City'}
            defaultvalue={destinationCity?.name || ''}
            value={destinationCity?.name || ''}
            width="100%"
            searchPlaceholder={od.searchDestinationCity || `Search Destination City`}
            data={destinationCityList}
            dataKey={`name`}
            idKey={`id`}
            onSelect={handleDestCitySelect}
            onSelResetVal={true}
            disabled={!enableCityChange}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '19%' }}>
          <DropDownOA
            id="memoDestBranch"
            nextId="memoUser"
            prevId="memoDestCity"
            label={od.destinationBranch || 'Destination Branch'}
            type ={'set_default'}
            defaultvalue={destinationBranch?.name || ''}
            value={destinationBranch?.name || ''}
            width="100%"
            searchPlaceholder={od.searchDestinationBranch || `Search Destination Branch`}
            data={destinationBranchListFilter}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(value) => {
              setDestinationBranch(value)
              const filterUserList = userList.filter((a) => a.branchid === value?.id)
              setUserListFilter(filterUserList)
              setUser(filterUserList?.[0] || {})
              setIsExpanded(false)
            }}
            disabled={!enableBranchChange}
            onSelResetVal={true}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '19%' }}>
          <DropDownOA
            id="memoUser"
            nextId="memoGenerate"
            prevId="memoDestBranch"
            label={od.selectUser || 'Select User'}
            type ={'set_default'}
            defaultvalue={user?.name || ''}
            value={user?.name || ''}
            width="100%"
            searchPlaceholder={od.searchSelectUser || `Search Select User`}
            data={userListFilter}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(value) => {
              setUser(value)
              setIsExpanded(false)
            }}
            onSelResetVal={true}
          />
        </Item>
        <Box sx={{ ...sx.reportFlex, padding: '0px', justifyContent: 'start', width: '40%', flexWrap: 'nowrap' }}>
          <Button
            id="memoGenerate"
            className="btn add-btn"
            style={{ margin: '0px', width: '100%', flex: 1 }}
            variant="contained"
            color="error"
            onClick={handleGenerate}
            onKeyDown={(e) => {
              navigation1(e, 'memoViewStatus', 'memoUser')
            }}
          >
            {cmn.generate || od.generate || 'generate'}
          </Button>
          <Button
            id="memoViewStatus"
            className="btn cancel-btn"
            style={{ margin: '0px', width: '100%', flex: 1 }}
            variant="outlined"
            color="error"
            onKeyDown={(e) => {
              navigation1(e, 'memoToggleFilter', 'memoGenerate')
            }}
          >
            {od.viewStatus || 'View Status'}
          </Button>
          <Button
            id="memoToggleFilter"
            variant="text"
            color="primary"
            endIcon={showMore ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            onClick={handleToggle}
            onKeyDown={(e) => {
              navigation1(e, showMore ? 'memoChallanNo' : 'memoFromDate', 'memoViewStatus')
            }}
            style={{
              textDecoration: 'underline',
              border: 'none',
              boxShadow: 'none',
              outline: 'none',
              fontWeight: 'bold',
              paddingLeft: '0px 0px',
              fontSize: '12px',
              width: '130px',
              flex: 1,
              width: '100%',
            }}
          >
            {showMore ? (od.lessFilters || 'Less Filters') : (od.moreFilters || 'More Filters')}
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          ...sx.reportFlex,
          justifyContent: 'start',
          paddingLeft: '15px',
          display: showMore ? 'flex' : 'none',
          paddingTop: 0,
          paddingBottom: '12px',
        }}
      >
        <Item sx={{ ...sx.itemsx, width: '15%' }}>
          <DropDownOA
            idKey={`id`}
            dataKey={`name`}
            id="memoChallanNo"
            prevId="memoToggleFilter"
            nextId="memoSenderName"
            width="100%"
            label={od.challanNo || 'Challan No'}
            type ={'set_default'}
            defaultvalue={challanFilter?.name || ''}
            value={challanFilter?.name || ''}
            data={challanList}
            noCross={true}
            onSelect={(val) => {
              setChallanFilter(val)
              setFilters((prev) => ({ ...prev, ChallanNo: val.name }))
            }}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '15%' }}>
          <DropDownOA
            idKey={`id`}
            dataKey={`name`}
            id="memoSenderName"
            prevId="memoChallanNo"
            nextId="memoSenderMobileNo"
            width="100%"
            label={od.senderName || 'Sender Name'}
            type ={'set_default'}
            defaultvalue={senderNameFilter?.name || ''}
            value={senderNameFilter?.name || ''}
            data={senderNameList}
            noCross={true}
            onSelect={(val) => {
              setSenderNameFilter(val)
              setFilters((prev) => ({ ...prev, Sender: val.name }))
            }}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '15%' }}>
          <DropDownOA
            idKey={`id`}
            dataKey={`name`}
            id="memoSenderMobileNo"
            prevId="memoSenderName"
            nextId="memoSenderGSTN"
            width="100%"
            label={od.senderMobileNo || 'Sender Mobile No'}
            type ={'set_default'}
            defaultvalue={senderNumberFilter?.name || ''}
            value={senderNumberFilter?.name || ''}
            data={senderNumberList}
            noCross={true}
            onSelect={(val) => {
              setSenderNumberFilter(val)
              setFilters((prev) => ({ ...prev, SenderMobileNo: val.name }))
            }}
          />
        </Item>
        {DefaultCurrencyID === 2 ? (
          <></>
        ) : (
          <Item sx={{ ...sx.itemsx, width: '15%' }}>
            <DropDownOA
              idKey={`id`}
              dataKey={`name`}
              id="memoSenderGSTN"
              prevId="memoSenderMobileNo"
              nextId="memoNext2"
              width="100%"
              label={od.senderGSTN || 'Sender GSTN'}
              type ={'set_default'}
              defaultvalue={senderGSTNFilter?.name || ''}
              value={senderGSTNFilter?.name || ''}
              data={senderGSTNList}
              noCross={true}
              onSelect={(val) => {
                setSenderGSTNFilter(val)
                setFilters((prev) => ({ ...prev, SenderGSTN: val.name }))
              }}
            />
          </Item>
        )}
         <Button
          id="memoNext2"
          style={{ background: cs.secondary.main, borderRadius: '6px', margin: '0px' }}
          onKeyDown={(e) => {
            navigation1(e, 'memoReset', 'memoSenderGSTN')
          }}
          className="btn add-btn"
          variant="contained"
          color="error"
          onClick={handleMoreFilter}
        >
          {cmn.go || 'GO'}
        </Button>
        <Button
          id="memoReset"
          className="btn cancel-btn"
          style={{ margin: '0px' }}
          variant="outlined"
          color="error"
          onKeyDown={(e) => {
            navigation1(e, 'memoFromDate', 'memoNext2')
          }}
          onClick={handleFilterReset}
        >
          {cmn.reset || 'RESET'}
        </Button>
      </Box>
      <Box
        sx={{ ...sx.reportFlex, padding: '0 0 0 15px', justifyContent: 'start', flexWrap: 'nowrap', fontSize: '16px', fontWeight: 'bold' }}
      >
        {od.updateOutDelivery || updateOutDelivery}
      </Box>
      <TableContainer
        className="delivery-memo-table scroll"
        component={Paper}
        ref={tableRef}
        sx={{
          height: tableHeight,
          borderRadius: '8px',
          border: '1px solid #aeaeae',
          overflow: 'auto',
          margin: '0px auto',
          width: 'calc(100% - 30px)',
        }}
      >
        <Table aria-label="a dense table">
          <TableHead>
            <TableRow sx={{ width: '100%', position: 'sticky', top: 0, zIndex: 1 }}>
              <TableCell
                style={{
                  textAlign: 'center',
                  backgroundColor: cs.primary.main,
                }}
              ></TableCell>
              {viewHeaders.map((header) => (
                <TableCell
                  key={header.field}
                  style={{
                    textAlign: header.xlCol.dataType === 'string' ? 'left' : 'right',
                    color: '#FFFFFF',
                    backgroundColor: cs.primary.main,
                    fontSize: '12px',
                    fontWeight: 500,
                    padding: '5px',
                    whiteSpace: 'pre',
                  }}
                >
                  {header.headerName}
                </TableCell>
              ))}
            </TableRow>

            <TableRow sx={{ width: '100%', position: 'sticky', top: '43px', zIndex: 1 }}>
              <TableCell
                style={{
                  textAlign: 'center',
                  backgroundColor: '#fff',
                  height: '50px',
                }}
              ></TableCell>
              {headerFields.includes('lrNumber') ? (
                <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre', background: '#FFF'  }}>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.lrNoDot}
                      onChange={(e) => handleChangeContain(e, 'LRNO')}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.offlineLrNoDot}
                      onChange={(e) => handleChangeContain(e, 'ManualLRNo')}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                </TableCell>
              ) : (
                <></>
              )}
              {headerFields.includes('receiveDate') ? (
                <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre', background: '#FFF' }}>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.date}
                      onChange={(e) => handleChangeContain(e, 'ReceiptDate')}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.challanNoDot}
                      onChange={(e) => handleChangeContain(e, 'ChallanNo')}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                </TableCell>
              ) : (
                <></>
              )}
              {headerFields.includes('sourceCityBranch') ? (
                <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre', background: '#FFF' }}>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.city}
                      onChange={(e) => handleChangeContain(e, 'BookingCity')}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.branch}
                      onChange={(e) => handleChangeContain(e, 'BookingBranch')}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                </TableCell>
              ) : (
                <></>
              )}
              {headerFields.includes('destinationCityBranch') ? (
                <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre', background: '#FFF' }}>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.city}
                      onChange={(e) => handleChangeContain(e, 'DestinationCity')}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.branch}
                      onChange={(e) => handleChangeContain(e, 'DestinationBranch')}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                </TableCell>
              ) : (
                <></>
              )}
              {headerFields.includes('paymentTypeAmt') ? (
                <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre', background: '#FFF' }}>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.paymentType}
                      onChange={(e) => handleChangeContain(e, 'PaymentTypeName')}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.dueAmount}
                      onChange={(e) => handleChangeContain(e, 'DueAmount')}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                </TableCell>
              ) : (
                <></>
              )}
              {headerFields.includes('totalNoOfUnits') ? (
                <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre', background: '#FFF' }}>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.noOfUnits}
                      disabled={true}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                </TableCell>
              ) : (
                <></>
              )}
              {headerFields.includes('freight') ? (
                <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre', background: '#FFF' }}>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.freight}
                      disabled={true}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                </TableCell>
              ) : (
                <></>
              )}
              {headerFields.includes('receverName') ? (
                <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre', background: '#FFF' }}>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.receiverName}
                      disabled={true}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                </TableCell>
              ) : (
                <></>
              )}
              {headerFields.includes('receiverNumber') ? (
                <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre', background: '#FFF' }}>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.receiverNumber}
                      disabled={true}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                </TableCell>
              ) : (
                <></>
              )}
              {headerFields.includes('assignedBy') ? (
                <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre', background: '#FFF' }}>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.assignedBy}
                      disabled={true}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                </TableCell>
              ) : (
                <></>
              )}
              {headerFields.includes('assignedDate') ? (
                <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre', background: '#FFF' }}>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.assignedDate}
                      disabled={true}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                </TableCell>
              ) : (
                <></>
              )}
              {headerFields.includes('ofdStatus') ? (
                <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre', background: '#FFF' }}>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.ofdStatus}
                      disabled={true}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                </TableCell>
              ) : (
                <></>
              )}
              {headerFields.includes('outDeliveryDate') ? (
                <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre', background: '#FFF' }}>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.totalOutstanding}
                      disabled={true}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                </TableCell>
              ) : (
                <></>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((row, index) => {
              const ReceiptDate = moment(row.ReceiptDate).format('DD-MM-YY')
              const OutDeliveryOtpAssignedDate = moment(row.OutDeliveryOtpAssignedDate).format('DD-MMM-YYYY')
              const paymenMode = methodOfPaymentData.find((i) => row.PaymentModeID === i.ModeID) || {}
              return (
                <TableRow key={index + 'sdfr323'}>
                  <TableCell style={{ padding: '5px', textAlign: 'center' }}>
                    <Checkbox
                      style={{
                        textAlign: 'center',
                      }}
                      checked={row?.checked || false}
                      onChange={handleCheck}
                      name={row.bookingid}
                    />
                  </TableCell>
                  {headerFields.includes('lrNumber') ? (
                    <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre' }}>
                      {`${row.LRNO}\n${row.ManualLRNo}`}
                    </TableCell>
                  ) : (
                    <></>
                  )}
                  {headerFields.includes('receiveDate') ? (
                    <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre' }}>
                      {`${ReceiptDate}\n${row.ChallanNo}`}
                    </TableCell>
                  ) : (
                    <></>
                  )}
                  {headerFields.includes('sourceCityBranch') ? (
                    <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre' }}>
                      {`${row.BookingCity}\n${row.BookingBranch}`}
                    </TableCell>
                  ) : (
                    <></>
                  )}
                  {headerFields.includes('destinationCityBranch') ? (
                    <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre' }}>
                      {`${row.DestinationCity}\n${row.DestinationBranch}`}
                    </TableCell>
                  ) : (
                    <></>
                  )}
                  {headerFields.includes('paymentTypeAmt') ? (
                    <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre' }}>
                      <div
                        style={{
                          backgroundColor: colors[row.PaymentTypeId],
                          padding: '2px 8px',
                          height: '25px',
                          margin: '2px 0 4px 0',
                          textDecoration: row.PaymentTypeName?.length > 7 ? 'underline' : '',
                        }}
                        title={row.PaymentTypeName}
                      >
                        {row.PaymentTypeName}
                      </div>
                      <div className="disabled-input">{row.DueAmount}</div>
                    </TableCell>
                  ) : (
                    <></>
                  )}
                  {headerFields.includes('totalNoOfUnits') ? (
                    <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre' }}>
                      <div className="disabled-input" style={{ justifyContent: 'end' }}>
                        {row.Units}{' '}
                      </div>
                      <DropDownOA
                        portal={true}
                        defaultvalue={paymenMode?.ModeName || ''}
                        data={methodOfPaymentData}
                        onSelect={(val) => hanlePaymentmode(val, row.bookingid)}
                        listWidth="200px"
                        dataKey="ModeName"
                        idKey="ModeID"
                        noCross={true}
                      />
                    </TableCell>
                  ) : (
                    <></>
                  )}
                  {headerFields.includes('freight') ? (
                    <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre' }}>
                      <div className="disabled-input" style={{ justifyContent: 'end' }}>
                        {row.Freight}{' '}
                      </div>
                      <LineInputV3
                        placeholder={fp.deliveryCartage}
                        name={row.bookingid + '||AdditionalDeliveryCartage'}
                        value={row.AdditionalDeliveryCartage}
                        onBlur={hanleInput}
                        sx={{ textAlign: 'right' }}
                      />
                    </TableCell>
                  ) : (
                    <></>
                  )}
                  {headerFields.includes('receverName') ? (
                    <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre' }}>
                      <LineInputV3 placeholder={fp.receiverName} name={row.bookingid + '||RecName'} value={row.RecName} onBlur={hanleInput} />
                      <LineInputV3
                        placeholder={fp.deliveryHamali}
                        name={row.bookingid + '||AdditionalHamaliCharges'}
                        value={row.AdditionalHamaliCharges}
                        onBlur={hanleInput}
                        sx={{ textAlign: 'right' }}
                      />
                    </TableCell>
                  ) : (
                    <></>
                  )}
                  {headerFields.includes('receiverNumber') ? (
                    <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre' }}>
                      <LineInputV3
                        placeholder={fp.receiverMobileNo}
                        name={row.bookingid + '||RecMobileNo'}
                        value={row.RecMobileNo}
                        onBlur={hanleInput}
                      />
                      <LineInputV3
                        placeholder={fp.deliveryOpHamali}
                        name={row.bookingid + '||ExtraHamali'}
                        value={row.ExtraHamali}
                        onBlur={hanleInput}
                        sx={{ textAlign: 'right' }}
                      />
                    </TableCell>
                  ) : (
                    <></>
                  )}
                  {headerFields.includes('assignedBy') ? (
                    <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre' }}>
                      <div className="disabled-input">{row.OutDeliveryOtpAssignedBy}</div>
                      <LineInputV3
                        placeholder={fp.demurrageChr}
                        name={row.bookingid + '||DemurrageChg'}
                        value={row.DemurrageChg}
                        onBlur={hanleInput}
                        sx={{ textAlign: 'right' }}
                      />
                    </TableCell>
                  ) : (
                    <></>
                  )}
                  {headerFields.includes('assignedDate') ? (
                    <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre' }}>
                      <div className="disabled-input">{OutDeliveryOtpAssignedDate}</div>
                      <LineInputV3
                        placeholder={fp.discountDelivery}
                        name={row.bookingid + '||DeliveryDisc'}
                        value={row.DeliveryDisc}
                        onBlur={hanleInput}
                        sx={{ textAlign: 'right' }}
                      />
                    </TableCell>
                  ) : (
                    <></>
                  )}
                  {headerFields.includes('ofdStatus') ? (
                    <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre' }}>
                      <div
                        style={{
                          backgroundColor: row.Status === 'Out Delivered' ? '#CCFFDD' : '#FE5200',
                          padding: '2px 8px',
                          height: '25px',
                          margin: '2px 0 4px 0',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {translateOutDeliveryStatus(row.Status, translations)}
                      </div>
                      <div className="disabled-input" style={{ justifyContent: 'end' }}>
                        {row.DeliveryGST}
                      </div>
                    </TableCell>
                  ) : (
                    <></>
                  )}
                  {headerFields.includes('outDeliveryDate') ? (
                    <TableCell style={{ padding: '5px', textAlign: 'left', whiteSpace: 'pre' }}>
                      <div className="disabled-input" style={{ justifyContent: 'end' }}>
                        {row.Outstanding}
                      </div>
                    </TableCell>
                  ) : (
                    <></>
                  )}
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ padding: '0 15px', height: '65px', display: 'flex', justifyContent: 'end', background: '#F0FCF4' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '14px', fontWeight: 500 }}>
          {od.otpOn || 'OTP On:'}
          <label
            htmlFor={'whatsappOTP'}
            style={{
              fontFamily: 'Roboto',
              fontSize: '12px',
              fontWeight: '500',
              color: '#444444',
              flexWrap: 'nowrap',
            }}
          >
            <Radio
              id={'whatsappOTP'}
              name={`dateWiseRadio`}
              size={'medium'}
              value="1"
              checked={otpOn === 1}
              onChange={handleOTPChange}
              onKeyDown={(e) => handleKeyDown(e)}
            />
            {od.whatsapp || 'WhatsApp'}
          </label>
          <label
            htmlFor={'smsOTP'}
            style={{
              fontFamily: 'Roboto',
              fontSize: '12px',
              fontWeight: '500',
              color: '#444444',
              flexWrap: 'nowrap',
            }}
          >
            <Radio
              id={'smsOTP'}
              name={`dateWiseRadio`}
              size={'medium'}
              value="1"
              checked={otpOn === 2}
              onChange={handleOTPChange}
              onKeyDown={(e) => handleKeyDown(e)}
            />
            {od.sms || 'SMS'}
          </label>
          <Button
            id="memoNext2"
            style={{ background: cs.secondary.main, borderRadius: '6px', margin: '0px' }}
            onKeyDown={(e) => {
              navigation1(e, 'memoSourceCity', 'memoAllLr')
            }}
            className="btn add-btn"
            variant="contained"
            color="error"
            onClick={handleDeliver}
          >
            {od.deliver || cmn.deliver || 'Deliver'}
          </Button>
          {tableData.filter(a => a.checked === true).find(a => ![2, 4].includes(a.PaymentTypeId)) ? <></> :
            <Button
              id="memoNext2"
              style={{ background: cs.secondary.main, borderRadius: '6px', margin: '0px' }}
              onKeyDown={(e) => {
                navigation1(e, 'memoSourceCity', 'memoAllLr')
              }}
              className="btn add-btn"
              variant="contained"
              color="error"
              onClick={handleDeliverWithMpesa}
            >
              {od.deliverWithMpesa || 'Deliver With M-Pesa'}
            </Button>}
          <Button
            id="memoGenerate"
            className="btn cancel-btn"
            style={{ margin: '0px' }}
            variant="outlined"
            color="error"
            onClick={handleReturn}
            onKeyDown={(e) => {
              navigation1(e, 'memoToggleFilter', 'memoDestCity')
            }}
          >
            {od.returnLabel || 'return'}
          </Button>
        </Box>
      </Box>
      {showMpesa ? <BookingConfirmMpesa data={mpesaData} updateModal={setShowMpesa} /> : <></>}
      {modal === 'OTP' && <OTPModal OTP={OTP} updateModal={setModal} saveApi={deliverLRs} sendOTPRequest={handleDeliver} />}
      {modal === 'OTPReturn' && <OTPModal OTP={OTP} updateModal={setModal} saveApi={returnLRs} sendOTPRequest={handleReturn} />}
    </Item>
  )
}
